import UserPropertyEntity from './user_property_entity';
import ContractMemberEntity from '../contract/contract_member_entity';
import IUserEntity from "../../interfaces/iuser_entity.type";

export default class UserEntity {
   private readonly id: string;
   private readonly username: string | undefined;
   private readonly email: string | undefined;
   private readonly firstName: string | undefined;
   private readonly lastName: string | undefined;
   private readonly displayName: string | undefined;
   private readonly verifiedEmail: boolean;
   private readonly roles: string[] | undefined;
   private readonly properties: UserPropertyEntity | undefined;
   private readonly phoneNumber: string | undefined;
   private readonly phoneVerified: boolean;
   private readonly created: string;
   private readonly contractIds: ContractMemberEntity[]| undefined;
   private readonly authTypes: string[] | undefined;
   constructor(
     userProperties: IUserEntity
   ) {
      this.id = userProperties.id;
      this.username = userProperties.username;
      this.email = userProperties.email;
      this.firstName = userProperties.first_name;
      this.lastName = userProperties.last_name;
      this.displayName = userProperties.display_name;
      this.verifiedEmail = userProperties.verified_email;
      this.roles = userProperties.roles;
      this.properties = userProperties.properties;
      this.phoneNumber = userProperties.phone_number;
      this.phoneVerified = userProperties.phone_verified;
      this.created = userProperties.created;
      this.contractIds = userProperties.contract_ids;
      this.authTypes = userProperties.auth_types;
   }
   getId = () => this.id;
   getUsername = () => this.username;
   getEmail = () => this.email;
   getFirstName = () => this.firstName;
   getLastName = () => this.lastName;
   getDisplayName = () => this.displayName;
   getVerifiedEmail = () => this.verifiedEmail;
   getRoles = () => this.roles;
   getProperties = () => this.properties instanceof UserPropertyEntity? this.properties.toObject() : undefined;
   getPhoneNumber = () => this.phoneNumber;
   getPhoneVerified = () => this.phoneVerified;
   getCreated = () => this.created;
   getAuthTypes = () => this.authTypes;
   getContractIds = () => this.contractIds && this.contractIds.length
      ? this.contractIds.map((contracts: ContractMemberEntity) => contracts.toObject())
      : undefined;
   toObject = () => ({
      id: this.getId(),
      username: this.getUsername(),
      email: this.getEmail(),
      firstName: this.getFirstName(),
      lastName: this.getLastName(),
      displayName: this.getDisplayName(),
      verifiedEmail: this.getVerifiedEmail(),
      roles: this.getRoles(),
      properties: this.getProperties(),
      phoneNumber: this.getPhoneNumber(),
      phoneVerified: this.getPhoneVerified(),
      created: this.getCreated(),
      authTypes: this.getAuthTypes(),
      contractIds: this.getContractIds()
   });
}
